import { render, staticRenderFns } from "./TabsItem.vue?vue&type=template&id=8993ca42&"
import script from "./TabsItem.vue?vue&type=script&lang=js&"
export * from "./TabsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/danford/drochat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8993ca42')) {
      api.createRecord('8993ca42', component.options)
    } else {
      api.reload('8993ca42', component.options)
    }
    module.hot.accept("./TabsItem.vue?vue&type=template&id=8993ca42&", function () {
      api.rerender('8993ca42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/Tabs/TabsItem.vue"
export default component.exports